<template>
  <div>
    <el-dialog v-model="interstingShow" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="header">告诉我你的学习兴趣</div>
        <div class="close_icon cursor_pointer" @click="closePopup">
          <el-icon :size="24">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="content">
          <div class="peroid_one">
            <div class="flex peroid_top Flexalign">
              <el-image class="peroid_icon" :src="imgPath('peroid_icon.png')"></el-image>
              <div class="peroid_name">当前学段</div>
            </div>
            <div class="list_box flex FlexWrap mar_top_10">
              <div
                class="btn_list cursor_pointer"
                v-for="(item, index) in stageList"
                :key="index"
                :class="[item.stageId == selectInfo.selectStage ? 'active_select' : '']"
                @click="selectElement('stage', item)"
              >
                {{ item.stageName }}
              </div>
            </div>
          </div>
          <div class="peroid_one">
            <div class="flex peroid_top Flexalign">
              <el-image class="peroid_icon" :src="imgPath('area_icon.png')"></el-image>
              <div class="peroid_name">所在地区</div>
            </div>
            <div class="list_box flex FlexWrap mar_top_10">
              <div
                class="btn_list cursor_pointer"
                v-for="(item, index) in provinceList"
                :key="index"
                :class="[
                  item.provinceId == selectInfo.selectProvince ? 'active_select' : '',
                ]"
                @click="selectElement('province', item)"
              >
                {{ item.provinceName }}
              </div>
            </div>
          </div>
          <div class="peroid_one">
            <div class="flex peroid_top Flexalign">
              <el-image class="peroid_icon" :src="imgPath('subject_icon.png')"></el-image>
              <div class="peroid_name">喜欢学科</div>
            </div>
            <div class="list_box flex FlexWrap mar_top_10">
              <div
                class="btn_list cursor_pointer"
                v-for="(item, index) in subjectList"
                :key="index"
                :class="[getSubjectClass(item.subjectId)]"
                @click="selectElement('subject', item)"
              >
                {{ item.subjectName }}
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_box flex Flexjustify Flexalign cursor_pointer">
          <div class="btn" @click="updateInterestign">
            {{ isSelectOne ? "确定" : "至少选择一项" }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import area from "@/assets/data/area";
import { mapState } from "vuex";
export default {
  name: "GjkcH5Login",

  data() {
    return {
      interstingShow: false,
      // gradeList: [],
      subjectList: [],
      provinceList: [],
      isSelectOne: false,
      selectInfo: {
        selectStage: "",
        selectSubject: [],
        selectProvince: "",
      },
    };
  },
  computed: {
    ...mapState({
      stageList: (state) => state.filter.stageList,
      // subjectList:state => state.filter.subjectList,
    }),
  },
  watch: {
    selectInfo: {
      handler() {
        if (
          this.selectInfo.selectProvince ||
          this.selectInfo.selectSubject ||
          this.selectInfo.selectStage
        ) {
          this.isSelectOne = true;
        } else {
          this.isSelectOne = false;
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.getProvince();
    this.selectInfo.selectStage = this.stageList[0]?.stageId;
    setTimeout(()=>{
      this.changeStage(this.stageList[0]);
    },500)
  },

  methods: {
    getSubjectClass(subjectId) {
      let index = this.selectInfo.selectSubject.findIndex((item) => item == subjectId);
      if (index == -1) {
        return "";
      } else {
        return "active_select";
      }
    },
    // 选择兴趣
    selectElement(type, info) {
      if (type == "stage") {
        // if (this.selectInfo.selectStage == info.gradeId) {
        //   this.selectInfo.selectStage = '';
        // } else {
        // this.selectInfo.selectStage = info.stageId;
        this.changeStage(info);
        // }
      } else if (type == "subject") {
        // if (this.selectInfo.selectSubject == info.subjectId) {
        //   this.selectInfo.selectSubject = '';
        // } else {
        //   this.selectInfo.selectSubject = info.subjectId;
        // }
        let index = this.selectInfo.selectSubject.findIndex(
          (item) => item == info.subjectId
        );
        if (index == -1) {
          this.selectInfo.selectSubject.push(info.subjectId);
        } else {
          this.selectInfo.selectSubject.splice(index, 1);
        }
      } else if (type == "province") {
        if (this.selectInfo.selectProvince == info.provinceId) {
          this.selectInfo.selectProvince = "";
        } else {
          this.selectInfo.selectProvince = info.provinceId;
        }
      }
    },
    changeStage(info) {
      this.selectInfo.selectStage = info?.stageId;
      this.$Api.common
        .getSubject({ stageId: info.stageId })
        .then((res) => {
          this.subjectList = res.data.data;
        })
        .catch(() => {});
    },
    closePopup() {
      this.interstingShow = false;
      this.selectInfo = {
        selectStage: "",
        selectSubject: [],
        selectProvince: "",
      }
    },
    // 获取省列表
    getProvince() {
      for (let key in area.province_list) {
        this.provinceList.push({
          provinceId: key,
          provinceName: area.province_list[key],
        });
      }
    },
    // 设置兴趣爱好
    updateInterestign() {
      this.$Api.user
        .updatePersonalInfo({
          atStageIds: this.selectInfo.selectStage,
          atSubjectIds: this.selectInfo.selectSubject.join(","),
          provinceCode: this.selectInfo.selectProvince,
        })
        .then(() => {
          this.$Dialog.toast("设置成功");
          this.$Api.login.getUserInfo().then((response) => {
            this.$store.commit("setUserInfo", response.data.data);
            this.$emit("refreshPage");
            setTimeout(() => {
              this.closePopup();
            }, 1000);
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 20px 20px 10px 10px;
  padding: 0;
  width: 786px;
  height: 646px;
  position: relative;
}

:deep(.el-dialog__header) {
  position: relative;
}

.header {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color: #111111;
  line-height: 60px;
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
}

.dialog_content {
  .content {
    width: 100%;
    height: 480px;
    overflow: auto;

    .peroid_one {
      padding: 0 26px 15px;

      .peroid_top {
        font-size: 16px;
        color: #333333;

        .peroid_icon {
          width: 18px;
          height: 18px;
        }

        .peroid_name {
          margin-left: 10px;
        }
      }

      .list_box {
        .btn_list {
          width: 85px;
          height: 32px;
          border-radius: 16px;
          border: 1px solid #dfe1e3;
          margin: 0 8px 10px;
          font-size: 16px;
          color: #999999;
          line-height: 32px;
          text-align: center;
          box-sizing: border-box;
        }

        .active_select {
          background: linear-gradient(90deg, #00d5c2, #00d498);
          color: #ffffff;
          border: none;
        }
      }
    }
  }

  .bottom_box {
    width: 100%;
    height: 79px;
    box-shadow: 0px 0px 38px 0px rgba(0, 0, 0, 0.26);
    border-radius: 0px 0px 10px 10px;
    position: absolute;
    bottom: 0;

    .btn {
      width: 165px;
      height: 36px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 18px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
    }
  }
}
</style>
